import * as Yup from 'yup'

const miscTasksVerificationSchema = Yup.object().shape({
  userIds: Yup.array()
    .of(Yup.string())
    .required('User(s) is required'),
  dateRange: Yup.array().required('Date range is required'),
  taskTypes: Yup.array().required('Task type(s) is required'),
})

export default miscTasksVerificationSchema
